import { GButton } from "../../../components/GButton";
import styles from "./css/SignInButton.module.css";
import { KeycloakClientFactory } from "../../../helper/keycloak/factory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";

const SignUpButton = () => {
  const keycloak = KeycloakClientFactory.getInstance();

  return (
    <GButton
      data-testid="sign-in-btn"
      className={styles.signBtn}
      color="primary"
      variant="contained"
      startIcon={<FontAwesomeIcon icon={faUserPlus} />}
      onClick={() => keycloak.register()}
    >
      Sign Up
    </GButton>
  )
};

export default SignUpButton;
